import { render, staticRenderFns } from "./abnormal-mate.vue?vue&type=template&id=1bf69168&scoped=true"
import script from "./abnormal-mate.vue?vue&type=script&lang=js"
export * from "./abnormal-mate.vue?vue&type=script&lang=js"
import style0 from "./abnormal-mate.vue?vue&type=style&index=0&id=1bf69168&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf69168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf69168')) {
      api.createRecord('1bf69168', component.options)
    } else {
      api.reload('1bf69168', component.options)
    }
    module.hot.accept("./abnormal-mate.vue?vue&type=template&id=1bf69168&scoped=true", function () {
      api.rerender('1bf69168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/store-manage/abnormal-mate.vue"
export default component.exports